import type { Locale } from "@/lib/i18n";
import { pl, type CCrmProjectManagementTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cCrmProjectManagementTranslations: Record<
  Locale,
  CCrmProjectManagementTranslations
> = {
  pl,
  en,
  de,
};

export type { CCrmProjectManagementTranslations };
